import { useCallback, useState } from 'react';

type UseResetableStateReturn<T> = readonly [T, React.Dispatch<React.SetStateAction<T>>, () => void];

const useResetableState = <T>(initialState: T): UseResetableStateReturn<T> => {
    const [stateValue, setStateValue] = useState<T>(initialState);

    // Wrapping up the reset function in a useCallback will improve performance
    // when using it in dependency arrays.
    const resetStateValue = useCallback(() => {
        setStateValue(initialState);
    }, []);

    return [stateValue, setStateValue, resetStateValue];
};

export default useResetableState;
